import { camelCase } from 'lodash';
/**
 * Formats keys in an object to the specified casing
 */
export class CaseFormatter {
    /**
     * Recursively set PascalCase object to camelCase
     * might be the one case where type of 'any' makes sense...
     * @param pascalObject
     */
    static pascalToCamelCase(pascalObject) {
        if (pascalObject === null || typeof pascalObject !== 'object') {
            return pascalObject;
        }
        if (Array.isArray(pascalObject)) {
            return pascalObject.map(this.pascalToCamelCase);
        }
        const camelObject = {};
        Object.keys(pascalObject).forEach((pascalKey) => {
            const camelKey = pascalKey.charAt(0).toLowerCase() + pascalKey.slice(1);
            camelObject[camelKey] = CaseFormatter.pascalToCamelCase(pascalObject[pascalKey]);
        });
        return camelObject;
    }
    /**
     * Recursively set camelCase object to PascalCase
     * might be the one case where type of 'any' makes sense...
     * @param pascalObject
     */
    static camelToPascalCase(camelObject) {
        if (camelObject === null || typeof camelObject !== 'object') {
            return camelObject;
        }
        if (Array.isArray(camelObject)) {
            return camelObject.map(this.camelToPascalCase);
        }
        const PascalObject = {};
        Object.keys(camelObject).forEach((camelKey) => {
            const pascalKey = camelKey.charAt(0).toUpperCase() + camelKey.slice(1);
            PascalObject[pascalKey] = CaseFormatter.camelToPascalCase(camelObject[camelKey]);
        });
        return PascalObject;
    }
    /**
     * Set incoming text to PascalCase
     * @param text Text to process
     */
    static toPascalCase(text) {
        return text
            ? text.replace(/\w\S*/g, textVal => {
                return textVal.charAt(0).toUpperCase() + textVal.substr(1).toLowerCase();
            })
            : text;
    }
    /**
     * Set incoming text to Camel case
     * @param text Text to process
     */
    static toCamelCase(text) {
        return text.replace(/\w\S*/g, textVal => {
            return textVal.charAt(0).toLowerCase() + textVal.substr(1);
        });
    }
}
/**
 * Recursively set any object keys to camelCase. These keys can also be space-separated,
 * dash-separated, or can be separated by underscores
 * @param object: Object with case-separated, space-separated, dash-separated, or underscore-separated keys
 */
CaseFormatter.anyObjectToCamelCase = (object) => {
    if (Array.isArray(object)) {
        return object.map(element => CaseFormatter.anyObjectToCamelCase(element));
    }
    else if (object !== null && object.constructor === Object) {
        return Object.keys(object).reduce((result, key) => (Object.assign(Object.assign({}, result), { [camelCase(key)]: CaseFormatter.anyObjectToCamelCase(object[key]) })), {});
    }
    return object;
};
/**
 *
 * @param value value to be converted to sentence case
 */
CaseFormatter.toSentenceCase = (value) => {
    const result = value.replace(/([A-Z])/g, ' $1');
    return `${result.charAt(0).toUpperCase()}${result.slice(1)}`;
};
//# sourceMappingURL=CaseFormatter.js.map